import { Typography, makeStyles } from "@material-ui/core";
import * as React from "react";

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
    paddingLeft: theme.spacing(1),
    borderLeft: `4px solid ${theme.palette.primary.main}`
  },
  title: {
    fontWeight: "bold",
    lineHeight: 1
  },
  subTitle: {
    marginLeft: theme.spacing(1)
  }
}));

const StripedTitle = ({ children, subTitle }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {React.isValidElement(children) ? (
        children
      ) : (
        <>
          <Typography
            variant="subtitle1"
            className={classes.title}
            component={subTitle ? "span" : undefined}
          >
            {children}
          </Typography>
          {subTitle && (
            <Typography
              variant="body2"
              color="textSecondary"
              component="span"
              className={classes.subTitle}
            >
              {subTitle}
            </Typography>
          )}
        </>
      )}
    </div>
  );
};

export default StripedTitle;
